import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3
              className="text-lg font-bold mb-4"
              style={{ fontFamily: 'var(--font-heading)' }}
            >
              蜜芽永不失联
            </h3>
            <p className="text-sm text-gray-400 leading-relaxed">
              为您整合蜜芽最新官方联系方式、客服入口、订单查询及社群渠道，确保每位用户随时都能找到蜜芽、获取售后支持与促销资讯。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-gray-300">
              分类导航
            </h4>
            <div className="flex flex-col gap-2">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-gray-400 hover:text-white transition-colors whitespace-nowrap"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-gray-300">
              快速链接
            </h4>
            <div className="flex flex-col gap-2">
              <Link
                to="/about"
                className="text-sm text-gray-400 hover:text-white transition-colors whitespace-nowrap"
              >
                关于我们
              </Link>
              <Link
                to="/"
                className="text-sm text-gray-400 hover:text-white transition-colors whitespace-nowrap"
              >
                首页
              </Link>
              <a
                href="#contact"
                className="text-sm text-gray-400 hover:text-white transition-colors whitespace-nowrap"
              >
                联系我们
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-gray-500">
            &copy; 2026 蜜芽永不失联. All rights reserved.
          </p>
          <p className="text-xs text-gray-500">
            本站为非官方信息聚合平台，旨在帮助用户随时找到蜜芽官方渠道
          </p>
        </div>
      </div>
    </footer>
  );
}